import request from '@/utils/request'
// 用户消息列表
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4242
export function getUserMessageList (params) {
  return request({
    url: `/notify/notifierPro/user`,
    method: 'get',
    params
  })
}
// 消息列表
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4237
export function getMessageList (params) {
  return request({
    url: `/notify/notifierPro`,
    method: 'get',
    params
  })
}
// 消息详情
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4241
export function getMessageDetail (id) {
  return request({
    url: `/notify/notifierPro/${id}`,
    method: 'get'
  })
}
// 消息添加
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4240
export function addMessage (data) {
  return request({
    url: `/notify/notifierPro`,
    method: 'post',
    data
  })
}
// 消息批量添加
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4239
export function batchAddMessage (data) {
  return request({
    url: `/notify/notifierPro/all`,
    method: 'post',
    data
  })
}
// 消息删除
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4238
export function delMessage (id) {
  return request({
    url: `/notify/notifierPro/${id}`,
    method: 'delete'
  })
}
// 消息导出
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4677
export function exportMessage (params) {
  return request({
    url: `/notify/notifierPro/export`,
    method: 'get',
    params
  })
}
// 置顶消息
// http://192.168.1.105:8082/workspace/myWorkspace.do?projectId=88#4713
export function getTopMessage (params) {
  return request({
    url: `/notify/notifierPro/top`,
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/message.js